// extracted by mini-css-extract-plugin
module.exports = {"header_layout":"styles_header_layout__RXUhA","header_item_layout":"styles_header_item_layout__DyD9i"};